// extracted by mini-css-extract-plugin
export default {"form":"ProcessNew_form__zPnGy","item":"ProcessNew_item__cq3Zy","buttons":"ProcessNew_buttons__FKubJ"};